import React from 'react'
import styled from 'styled-components'
import { Grid, TextField, InputAdornment, Hidden, useMediaQuery } from '@material-ui/core'
import { string, func } from 'prop-types'
import { ArrowForwardIos, Search } from '@material-ui/icons'
import { useHistory, useLocation } from 'react-router-dom'

const Container = styled.div`
  font-weight: bold;
  font-size: 1.2em;
  border-top: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  padding: 10px 0px;
  margin-bottom: 20px;
  & fieldset {
    border: 1px solid var(--second)!important
  }
  @media screen and (max-width:959px) {
    margin-bottom: 0px;
    border-top: 1px solid rgb(243,245,247);
    border-bottom: 1px solid rgb(243,245,247);
  }
`

const Bread = styled(Grid)`
  text-transform: uppercase;
  display: flex;
  align-items: center;
`
const TextFieldStyled = styled(TextField)`
  fieldset {
    border: 2px solid var(--first)!important;
  }
`

const Header = props => {
  const isMobile = useMediaQuery('(max-width:600px)')
  const history = useHistory()
  const { pathname, search } = useLocation()

  const handleChange = (event) => {
    if (pathname !== '/tienda') return history.push(`/tienda?keywords=${event.target.value}`)
    props.setkeyword(event.target.value)
  }

  return (
    <Container>
      <Grid container>
        <Hidden xsDown>
          <Bread item xs={6} style={{ color: props.category ? '#cdcdcd' : 'var(--fisrt)' }}>
            Tienda
            {props.category && (
              <>
                <span style={{ margin: '0px 15px' }}>
                  <ArrowForwardIos style={{ fontSize: '14px' }} />
                </span>
                <span style={{ color: 'var(--first)' }}>
                  {props.category}
                </span>
              </>
            )}
          </Bread>
        </Hidden>
        <Grid item xs={12} sm={6} container justify='flex-end'>
          <TextFieldStyled
            autoFocus={!!search}
            fullWidth={isMobile}
            placeholder='Buscar'
            onChange={handleChange}
            focused
            value={props.keyword || ''}
            variant='outlined'
            size='small'
            color='secondary'
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <Search style={{ color: 'var(--first)' }} />
                </InputAdornment>
              )
            }}
          />
        </Grid>
      </Grid>
    </Container>
  )
}

Header.propTypes = {
  category: string,
  keyword: string,
  setkeyword: func
}

export default Header
